import { api } from './api';
import type { Project } from './types';

export type HomeResult<T> = { data: T; error?: never } | { data?: never; error: string };

export function settle<T>(request: Promise<T>): Promise<HomeResult<T>> {
  return request.then(data => ({ data }), reason => ({ error: reason instanceof Error ? reason.message : 'Could not load this information.' }));
}

export function loadHomeData(signal: AbortSignal) {
  return {
    projects: settle(api.projects({ signal }).then(result => {
      const projects = Array.isArray(result) ? result : result.projects || [];
      return [...projects].sort((a, b) => String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')));
    }))
  };
}

export type HomeLoaderData = {
  projects: Promise<HomeResult<Project[]>>;
};
